import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthCallback from './components/AuthCallback';
import Dashboard from './components/Dashboard';
import History from './components/History';
import Login from './components/Login';
import Profile from './components/Profile';
import RaceDetail from './components/RaceDetail';
import DriverDetail from './components/DriverDetail';
import Footer from './components/Footer';
import Leaderboard from './components/Leaderboard';
import Groups from './components/Groups';
import Chatbot from './components/Chatbot';
import Feedback from './components/Feedback';
import { isAuthenticated } from './utils/auth';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app-layout">
        <div className="app-content">
          <Routes>
            <Route path="/" element={<Navigate to={isAuthenticated() ? '/dashboard' : '/login'} replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/history" element={<History />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/races/:id" element={<RaceDetail />} />
            <Route path="/drivers/:id" element={<DriverDetail />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/groups" element={<Groups />} />
          </Routes>
        </div>
        <Footer />
        {isAuthenticated() && <Chatbot />}
        {isAuthenticated() && <Feedback />}
      </div>
    </Router>
  );
}

export default App;
